import { createSelector } from 'reselect';
import Shipment from '~/types/Shipment';
import { ApplicationState } from '../store';

export const getShipmentsStore = (state: ApplicationState) => state.shipments;

export const getShipmentIdFromProps = (_, props: { shipmentId: string }): string =>
  props.shipmentId ? props.shipmentId : '';

export const getShipmentLoadingStates = createSelector(
  getShipmentsStore,
  (shipmentsStore) => shipmentsStore.loadState,
);

export const getShipmentsData = createSelector(
  getShipmentsStore,
  (shipmentsStore): { [shipmentObjectId: string]: Shipment } => shipmentsStore.data,
);

export const getShipmentByShipmentId = createSelector(
  getShipmentsData,
  getShipmentIdFromProps,
  (shipmentsData, shipmentId): Maybe<Shipment> => shipmentsData[shipmentId],
);

export const getShipmentIsLoading = createSelector(
  getShipmentLoadingStates,
  getShipmentIdFromProps,
  (loadingState, shipmentObjectId): boolean => !!loadingState[shipmentObjectId],
);
